.gate {
  display: flex;
  flex-direction: column;
  gap: 16px;
  padding: 8px 8px 0;
  text-align: left;
}

.title {
  color: #1a1a1a;
  font-size: 20px;
  font-weight: 700;
  margin: 0;
}

.body {
  color: #4a4a4a;
  font-size: 15px;
  line-height: 1.5;
  margin: 0;
}

.cta {
  background: transparent;
  border: 1px solid var(--brand-button-color);
  border-radius: 30px;
  color: var(--brand-button-color);
  cursor: pointer;
  font-weight: 600;
  margin-top: 8px;
  padding: 14px 28px;
  width: 100%;
}

.cta:hover {
  box-shadow: 0px 3px 12px 0px rgba(0, 0, 0, 0.12);
}
